module.exports = __webpack_public_path__ + "img/creame.8a4adf5.png";